import React, { Component } from "react";
import { INITIAL_STATE_LOGIN_FORM } from "../constants/general";

class LoginScreen extends Component {
  constructor(props) {
    super(props);
    this.state = INITIAL_STATE_LOGIN_FORM;

    this.handleEncryptedInput();
    this.handleLogin = this.handleLogin.bind(this);
    this.onChangeEmail = this.onChangeEmail.bind(this);
    this.onChangeAppId = this.onChangeAppId.bind(this);
  }

  handleEncryptedInput() {
    // string after last slash
    let input = window.location.pathname.split("/").slice(-1).join("/");

    input = input?.split("_").join("+");
    input = input?.split("-").join("/");

    var CryptoJS = require("crypto-js");

    // Decrypt
    try {
      var jsondata = CryptoJS.AES.decrypt(input, "JLJxR5ucQnMGVEB").toString(
        CryptoJS.enc.Utf8
      );
      if (!jsondata) {
        return;
      }
    } catch (err) {
      return;
    }

    const data = JSON.parse(jsondata);

    if (!data) {
      return;
    }

    // pokud je vk, nastavit
    if (data.vk.trim().length > 0) {
      this.setState({
        appid: data.vk,
        hideAppId: true,
      });
    }
    // pokud je snick, nastavit
    if (data.sn.trim().length > 0) {
      this.setState({
        nick: data.sn,
      });
    }
    // pokud je smail, nastavit
    if (data.sm.trim().length > 0) {
      this.setState({
        email: data.sm,
        hideEmail: true,
      });
    }
    // pokud je title, nastavit
    if (data.t.trim().length > 0) {
      this.setState({
        title: data.t,
      });
    }

    // pokud je idcontext, nastavit
    if (data.ctx.trim().length > 0) {
      this.setState({
        idcontext: data.ctx,
      });
    }
    // pokud je tgender, nastavit
    if (data.tg.trim().length > 0) {
      this.setState({
        tgender: data.tg,
      });
    }

    this.setState({ encryptedinput: true });
  }

  handleLogin(event) {
    event.preventDefault();

    // Check if appid and email are not empty
    if (this.state.appid && this.state.email) {
      this.props.handleLogin(
        this.state.appid,
        this.state.nick,
        this.state.email,
        this.state.tgender,
        this.state.idcontext
      );
    }
  }

  onChangeEmail(event) {
    this.setState({ email: event.target.value });
    if (!this.state.encryptedinput) {
      this.setState({ nick: "EMAIL" });
    }
  }
  onChangeAppId(event) {
    this.setState({ appid: event.target.value });
  }

  render() {
    let appIdInput = (
      <div className="form-row">
        <label htmlFor="appid">Access code</label>
        <input
          id="appid"
          name="appid"
          value={this.state.appid}
          className="form-input"
          onChange={this.onChangeAppId}
          required
        />
      </div>
    );

    let emailInput = (
      <div className="form-row">
        <label htmlFor="email">Nickname</label>
        <input
          id="email"
          name="email"
          className="form-input"
          value={this.state.email}
          required
          onChange={this.onChangeEmail}
        />
      </div>
    );

    if (this.state.encryptedinput) {
      if (this.state.hideAppId) {
        appIdInput = "";
      }
      if (this.state.hideEmail) {
        emailInput = "";
      }
    }

    return (
      <div className="App login">
        <form className="form" onSubmit={this.handleLogin}>
          <div className="form-title">{this.state.title}</div>
          {appIdInput}
          {emailInput}
          <button type="submit" className="mt-2">
            Enter
          </button>
        </form>
      </div>
    );
  }
}

export default LoginScreen;
